import React, { useEffect, useState } from "react";
 
import { useNavigate, useParams } from "react-router-dom";
import AddNewPayment from "./AddNewPayment";
import { Menu, message } from "antd";
import CertificationTable from "./certifications/CertificationTable";
import AuditsTable from "./audits/AuditsTable";
import DetailsTable from "./details/DetailsTable";
import Instance from "../../AxiosConfig";

const ComapanyDataCertification = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { id } = useParams(); 
const[companyData,setCompanyData]=useState({});
const [loading, setLoading] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const fetchCompanyDetails = async () => {
    // const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const response = await Instance.get(`/compony/${id}`,
      //    {
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //   },
      // }
    );

      if (response.status === 200 || response.status === 201) {
        console.log("Company Details:", response.data);
        setCompanyData(response.data)
      }
    } catch (error) {
      console.error("Error fetching company details:", error);
      message.error("Failed to load certifications.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchCompanyDetails();
  }, [id]);

  const items = [
    {
      label: "Certifications",
      key: "certification",
    },
    {
      label: "Audits",
      key: "audits",
    },
    {
      label: "Details",
      key: "details",
    },
  ];

  const [current, setCurrent] = useState("certification");

  const onClick = (e) => {
    setCurrent(e.key);
  };

  return (
    <>
    <div className="details-page">
          <div className="detials-page-heading">
            <div>
              <img className="levon-techno-img" src={companyData.logo} alt="" />
            </div>
            <div className="detials-page-heading-content">
              <h5>{companyData.companyName}</h5>
              {/* <p>{companyData.email}</p> */}
              <p><b>Address: </b>{companyData.address}</p>
            </div>
          </div>
        </div>
         <div className="setting-access mt-5">
      <div className="settings-access-container">
        <Menu
          onClick={onClick}
          selectedKeys={[current]}
          mode="horizontal"
          items={items}
          className="settings-access-menu"
        />
        <div className="tab-content">
          {current === "certification" && <CertificationTable/>}
          {current === "audits" && <AuditsTable  companyData={companyData}/>}
          {current === "details" && <DetailsTable companyData={companyData}/>}
        </div>
      </div>
      <AddNewPayment open={isModalOpen} handleCancel={handleCancel} />

       
    </div>
    </>
   
  );
};

export default ComapanyDataCertification;
